import axios from 'axios';

export default {
  get: (params) => axios.get('/api/v1/reports/stickers', { params }),
  importFile: (data) => axios.post('/api/v1/reports/stickers-import', data),
  generatePdf: (data) => axios.post('/api/v1/reports/stickers-generate-pdf', data),
};
